<script>
import { nextTick } from 'vue'

export default {
    name: "ContextMenu",

    props: {
        display: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            left: 0,
            top: 0,
            show: false
        }
    },

    computed: {
        style() {
            return {
                top: this.top + 'px',
                left: this.left + 'px'
            }
        }
    },

    methods: {
        close() {
            this.show = false
            this.left = 0
            this.top = 0
        },
        open(evt) {
            this.left = evt.pageX || evt.clientX
            this.top = evt.pageY || evt.clientY
            nextTick(() => this.$el.focus())
            this.show = true
        }
    }
}
</script>


<template>
    <div class="context-menu" v-show="show && display" :style="style" ref="context" tabindex="0" @blur="close">
        <slot></slot>
    </div>
</template>